exports.default = {
  'drag_files_here_or': '拖拽文件到这里或者',
  'click_to_upload': '点击上传',
  'supports_pdf_files_single_file_size_no_more_than_20m': '支持PDF文件，单个文件大小不超过20M，不支持扫描件，每次最多选择50个文件',
  'file_upload': '文件上传',
  'uploading': '正在上传',
  'upload_task_completed': '上传任务执行完毕',
  'upload_not_completed_cancel_all_ongoing_uploads': '上传尚未完成。要取消所有正在进行的上传吗?',
  'tips': '提示',
  'cancel_upload': '取消上传',
  'continue_upload': '继续上传',
  'executing': '执行中...',
  'upload_task_in_progress': '上传任务进行中...',
  'each_time_select_max_files': '每次最多选择{multiLimit}个文件，当前选择文件数量{filesLength}',
  'file_type_error': '文件类型错误!',
  'upload_avatar_image_can_only_be_jpg_or_png_format': '上传头像图片只能是JPG或PNG格式!',
  'upload_image_size_cannot_exceed_10m': '上传图片大小不能超过10M!',
  'upload_file_size_cannot_exceed_20m': '上传文件大小不能超过20M!',
  'uploaded_tasks_total_kb': '已上传 {uploadFiled} 个任务，共 {uploadSize} KB'
}
